// Section with Editor
$(document).on('shopify:section:load', function(e){ 
  $('#' + e.target.id).find('[data-section]').sectionJs();
}).ready(function() {
  $('[data-section]').each(function(){ $(this).sectionJs() });
});


$.fn.sectionJs = function(){
  var $this = this;
  if($this.data('section') == "SlideShow") {
    $this.find('.hero-slider').SlideShow();
  }
  else if($this.data('section') == "ProductTemplate") {
    $this.ProductTemplate();

  }
  else if($this.data('section') == "multipleproduct") {
    $this.multipleproduct();

  }

  
  
  
  else{}   
}

// Slide Show active js
$.fn.multipleproduct = function() {
  
  $('.small-product-slider').slick({
    arrows: false,
    dots: false,
    autoplay: false,
    infinite: true,
    slidesToShow: 4,
    rows: 2,
    prevArrow: '<button type="button" class="slick-prev"><i class="icofont icofont-long-arrow-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="icofont icofont-long-arrow-right"></i></button>',
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          autoplay: true,
          slidesToShow: 2,
          arrows: false,
        }
      },
      {
        breakpoint: 479,
        settings: {
          autoplay: true,
          slidesToShow: 1,
          arrows: false,
        }
      }
    ]
  });
  

  $('.best-deal-slider').slick({
    arrows: true,
    dots: false,
    autoplay: false,
    infinite: true,
    slidesToShow: 1,
    prevArrow: '<button type="button" class="slick-prev slick_nav"><i class="fa fa-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next slick_nav"><i class="fa fa-angle-right"></i></button>',
  });
  
  
  
}

// Slide Show active js
$.fn.SlideShow = function() {
  
  var heroSlider = $('.hero-slider');
  heroSlider.slick({
    arrows: true,
    autoplay: false,
    autoplaySpeed: 5000,
    dots: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    fade: true,
    infinite: true,
    slidesToShow: 1,
    prevArrow: '<button type="button" class="slick-prev"><i class="icofont icofont-long-arrow-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="icofont icofont-long-arrow-right"></i></button>',
  });
  
  
  
  
  
}



// Product Template active js
$.fn.ProductTemplate = function() {
  /*--
	Product Slider
-----------------------------------*/
  $('.pro-thumb-img').slick({
    arrows: true,
    dots: false,
    autoplay: false,
    infinite: true,
    slidesToShow: 4,
    prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 3,
        }
      }
    ]
  });
  $('.related-product-slider-1').slick({
    arrows: true,
    dots: false,
    autoplay: false,
    infinite: true,
    slidesToShow: 4,
    prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          autoplay: true,
          slidesToShow: 1,
          arrows: false,
        }
      }
    ]
  });
  $('.related-product-slider-2').slick({
    arrows: true,
    dots: false,
    autoplay: false,
    infinite: true,
    slidesToShow: 4,
    prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          autoplay: true,
          slidesToShow: 2,
          arrows: false,
        }
      }
    ]
  });

  /*----- 
	Product Zoom
--------------------------------*/
  // Instantiate EasyZoom instances
  var $easyzoom = $('.easyzoom').easyZoom();

  // Setup thumbnails example
  var api1 = $easyzoom.filter('.easyzoom--with-thumbnails').data('easyZoom');

  $('.pro-thumb-img').on('click', 'a', function(e) {
    var $this = $(this);

    e.preventDefault();

    // Use EasyZoom's `swap` method
    api1.swap($this.data('standard'), $this.attr('href'));
  });

  /*--
	Count Down Timer
------------------------*/
  $('[data-countdown]').each(function() {
    var $this = $(this), finalDate = $(this).data('countdown');
    $this.countdown(finalDate, function(event) {
      $this.html(event.strftime('<span class="cdown day"><span class="time-count">%-D</span> <p>Days</p></span> <span class="cdown hour"><span class="time-count">%-H</span> <p>Hours</p></span> <span class="cdown minutes"><span class="time-count">%M</span> <p>Mint</p></span> <span class="cdown second"><span class="time-count">%S</span> <p>Secs</p></span>'));
    });
  }); 
};






(function($) {
  "use strict";

  jQuery(document).ready(function(){


    $(window).on('load', function() {
      $('#preloader_active').fadeOut('slow');
    });


    /*-- Variables --*/
    var windows = $(window);
    var screenSize = windows.width();



    /*-- Product Hover Function --*/
    $(window).on('load', function(){
      function productHover() {

        var productInner = $('.product-inner');
        var proImageHeight = productInner.find('img').outerHeight();

        productInner.hover(
          function() {
            var porContentHeight = $( this ).find('.content').innerHeight()-55;
            $( this ).find('.image-overlay').css({
              "height": proImageHeight - porContentHeight,
            });
          }, function() {
            $( this ).find('.image-overlay').css({
              "height": '100%',
            });
          }
        );

      }
      productHover();
      windows.resize(productHover);
    });


    /*--
    Menu Sticky
-----------------------------------*/
    var sticky = $('.header-sticky');

    windows.on('scroll', function() {
      var scroll = windows.scrollTop();
      if (scroll < 300) {
        sticky.removeClass('is-sticky');
      }else{
        sticky.addClass('is-sticky');
      }
    });

    /*--
    Mobile Menu
------------------------*/
    var mainMenuNav = $('.main-menu nav');
    mainMenuNav.meanmenu({
      meanScreenWidth: '991',
      meanMenuContainer: '.mobile-menu',
      meanMenuClose: '<span class="menu-close"></span>',
      meanMenuOpen: '<span class="menu-bar"></span>',
      meanRevealPosition: 'right',
      meanMenuCloseSize: '0',
    });

    /*--
    Header Search
------------------------*/
    var searchToggle = $('.search-toggle');
    var searchWrap = $('.header-search-wrap');

    searchToggle.on('click', function(){

      if( !$(this).hasClass('active') ) {
        $(this).addClass('active');
        searchWrap.addClass('active');
      } else {
        $(this).removeClass('active');
        searchWrap.removeClass('active');
      }

    });
    /*--
    Header Cart
------------------------*/
    var headerCart = $('.header-cart');
    var closeCart = $('.close-cart, .cart-overlay');
    var miniCartWrap = $('.mini-cart-wrap');

    headerCart.on('click', function(e){
      e.preventDefault();
      $('.cart-overlay').addClass('visible');
      miniCartWrap.addClass('open');
    });
    closeCart.on('click', function(e){
      e.preventDefault();
      $('.cart-overlay').removeClass('visible');
      miniCartWrap.removeClass('open');
    });



    /*----- 
	Testimonial Slider
--------------------------------*/
    $('.testimonial-slider').slick({
      arrows: false,
      dots: false,
      autoplay: false,
      infinite: true,
      slidesToShow: 2,
      prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
          }
        },
      ]
    });

    /*--
	Brand Slider
-----------------------------------*/
    $('.brand-slider').slick({
      arrows: false,
      dots: false,
      autoplay: false,
      infinite: false,
      slidesToShow: 6,
      prevArrow: '<button type="button" class="slick-prev"><i class="icofont icofont-rounded-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next"><i class="icofont icofont-rounded-right"></i></button>',
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 5,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 479,
          settings: {
            slidesToShow: 2,
          }
        }
      ]
    });



    /*--
	MailChimp
-----------------------------------*/
    $('#mc-form').ajaxChimp({
      language: 'en',
      callback: mailChimpResponse,
      // ADD YOUR MAILCHIMP URL BELOW HERE!
      url: 'http://devitems.us11.list-manage.com/subscribe/post?u=6bbb9b6f5827bd842d9640c82&amp;id=05d85f18ef'

    });
    function mailChimpResponse(resp) {

      if (resp.result === 'success') {
        $('.mailchimp-success').html('' + resp.msg).fadeIn(900);
        $('.mailchimp-error').fadeOut(400);

      } else if(resp.result === 'error') {
        $('.mailchimp-error').html('' + resp.msg).fadeIn(900);
      }  
    }

    /*--
    Scroll Up
-----------------------------------*/
    $.scrollUp({
      easingType: 'linear',
      scrollSpeed: 900,
      animation: 'fade',
      scrollText: '<i class="icofont icofont-swoosh-up"></i>',
    });

    /*--
    Nice Select
------------------------*/
    $('.nice-select').niceSelect()

    /*--
	Price Range Slider
------------------------*/
    $('#price-range').slider({
      range: true,
      min: 0,
      max: 2000,
      values: [ 250, 1670 ],
      slide: function( event, ui ) {
        $('#price-amount').val( '$' + ui.values[ 0 ] + '  -  $' + ui.values[ 1 ] );
      }
    });
    $('#price-amount').val( '$' + $('#price-range').slider( 'values', 0 ) +
                           '  -  $' + $('#price-range').slider('values', 1 ) ); 

    /*----- 
	Quantity
--------------------------------*/
    $('.qtybtn').on('click', function() {
      var $button = $(this);
      var oldValue = $button.parent().find('input').val();
      if ($button.hasClass('inc')) {
        var newVal = parseFloat(oldValue) + 1;
      } else {
        // Don't allow decrementing below zero
        if (oldValue > 0) {
          var newVal = parseFloat(oldValue) - 1;
        } else {
          newVal = 0;
        }
      }
      $button.parent().find('input').val(newVal);
    });  

    /*----- 
	Shipping Form Toggle
--------------------------------*/ 
    $('[data-shipping]').on('click', function(){
      if( $('[data-shipping]:checked').length > 0 ) {
        $('#shipping-form').slideDown();
      } else {
        $('#shipping-form').slideUp();
      }
    })

    /*----- 
	Payment Method Select
--------------------------------*/
    $('[name="payment-method"]').on('click', function(){

      var $value = $(this).attr('value');

      $('.single-method p').slideUp();
      $('[data-method="'+$value+'"]').slideDown();

    })


    // Remove href
    $(".remove_href").removeAttr("href");

    $('.prod_price span:first-child').addClass('price');
    $('.prod_price span:nth-child(2)').addClass('old');



    //grid-color-swatch
    $('.grid-color-swatch li label').hover(function(){
      var variantImage = jQuery(this).parent().find('.hidden a').attr('href');
      jQuery(this).parents('.product_wrapper').find('.image > img').attr({ src: variantImage }); 
      return false;
    });


  });

})(jQuery);



